import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import _isObjectLike from 'lodash-es/isObjectLike';

@Injectable()
export class WorkflowModuleService {
  private _routersData$: BehaviorSubject<any>;

  private _submitSubject$: Subject<void>;
  private _workflowPayloadBehaviorSubject$: BehaviorSubject<any>;

  private _callback: any;

  set callback(callback: any) {
    this._callback = callback;
  }

  get callback() {
    return this._callback;
  }

  initRoutersDataSubject$<T>(value: T) {
    this._routersData$ = new BehaviorSubject<T>(value);
    return this._routersData$;
  }

  setRoutersDataValue(value) {
    this._routersData$.next(value);
  }

  initSubmitSubjects(subjectDefValue = null) {
    this._submitSubject$ = new Subject<void>();
    this._workflowPayloadBehaviorSubject$ = new BehaviorSubject(subjectDefValue);
  }

  onSubmit() {
    this._submitSubject$.next();
  }
  get submitSubject$() {
    return this._submitSubject$;
  }

  setWorkflowPayload(value) {
    const subjectVal = this._workflowPayloadBehaviorSubject$.getValue();
    if (_isObjectLike(subjectVal)) {
      value = Object.assign({}, subjectVal, value);
    }
    this._workflowPayloadBehaviorSubject$.next(value);
  }
  get successCompletionSubject$() {
    return this._workflowPayloadBehaviorSubject$;
  }
}
